<template>
  <v-card>
    <v-card-title>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Stichwörter filtern"
        single-line
        hide-details
        clearable
      />
    </v-card-title>

    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />

    <b-modal
      id="confirmDeleteKeyWord"
      ref="confirmDeleteKeyWord"
      hide-footer
      title="Stichwort löschen"
      no-fade
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie das Stichwort
        <em>'{{ keywordToDeleteName }}'</em>&nbsp;&nbsp;löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteKeyWordRelation()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant
        @click="hideModal"
      >
        Abbrechen
      </b-button>
    </b-modal>

    <v-data-table
      :headers="headers"
      :items="contractKeywords"
      class="elevation-1"
      rows-per-page-text="Stichwörter pro Seite"
      no-results-text="Keine Stichwörter gefunden"
      :rows-per-page-items="rowsPerPage"
      :search="search"
      :custom-filter="customSearchFilter"
    >
      <template v-slot:items="props">
        <td>
          <keyword-title :keyword="props.item" />
        </td>
        <td>
          <button
            v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
            v-b-modal.confirmDeleteKeyWord
            type="button"
            placement="bottom"
            title="Stichwort löschen"
            class="btn btn-danger float-right ml-1"
            @click="keywordToDelete = props.item"
          >
            <i class="fas fa-trash-alt" />
          </button>
        </td>
      </template>
    </v-data-table>
    <div>
      <div class="m-2 mt-3">
        <v-autocomplete
          v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
          v-model="keywordsToAdd"
          :items="allKeyWords"
          multiple
          return-object
          no-filter
          label="Stichwörter hinzufügen"
          hint="Zugeordnete Stichwörter auswählen"
          :loading="isLoading"
          :search-input.sync="searchToAdd"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            <div class="m-2 mutliselectSelectionItem">
              {{ data.item.titel }} ({{ data.item.language }})
              <button @click="removeKeyword(data.item)">
                <i class="fas fa-times" />
              </button>
            </div>
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            <div :id="data.item.keywordId">
              <keyword-title :keyword="data.item" />
            </div>
          </template>
          <template
            v-if="allKeyWords.length < totalNumberOfItems"
            slot="append-item"
          >
            <div
              class="loadMoreKeywords pt-2 pb-2"
              style="cursor: pointer"
              @click="
                maxNumberOfItems += 25;
                reloadAllKeyWords();
              "
            >
              <div class="ml-4">
                Mehr Items Stichwörter laden
              </div>
              <div class="ml-4">
                <b>Achtung! </b> Dies kann die Performance beeinträchtigen
              </div>
            </div>
          </template>
        </v-autocomplete>
      </div>

      <div
        v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
        class="buttonContainer"
      >
        <v-btn
          color="success"
          @click="addKeywordsToContract"
        >
          Hinzufügen
        </v-btn>
        <v-btn
          class="ml-2"
          color="danger"
          @click="cancelEditingKeywords"
        >
          Abbrechen
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import {
  GetKeywordsForContract,
  AddKeywordsToContract,
  DeleteKeywordFromContract,
} from "@/services/contract.keywords.service.js";
import { GetAllKeywords } from "@/services/keywords.service.js";
import KeywordTitle from "@/components/keywords/KeywordTitle.vue";
var S = require("string");

export default {
  components: {
    KeywordTitle,
  },
  props: {
    contractId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      keywordsToAdd: [],
      search: "",
      keywordToDelete: null,
      contractKeywords: [],
      errorObject: null,
      allKeyWords: [],
      maxNumberOfItems: 25,
      totalNumberOfItems: 0,
      isLoading: false,
      searchToAdd: null,
      rowsPerPage: [10, 25, 50, 100, { text: "Alle", value: -1 }],
      headers: [
        {
          text: "Stichwort",
          align: "left",
          value: "code",
        },
        { text: "", value: "code", sortable: false },
      ],
    };
  },
  computed: {
    keywordToDeleteName() {
      if (this.keywordToDelete != null) {
        return this.keywordToDelete.code;
      }

      return "!!NO KEYWORD!!";
    },
  },
  watch: {
    searchToAdd() {
      this.maxNumberOfItems = 25;
      this.reloadAllKeyWords();
    },
  },
  created: function () {
    this.reloadKeywordsForContract();
    this.reloadAllKeyWords();
  },

  methods: {
    customSearchFilter(items, search) {
      search = search.toString().toLowerCase();
      return items.filter((item) => {
        if (search == "") return true;

        var searchString = S(search.toLocaleLowerCase()).latinise();
        for (var i = 0; i < item.keywordContents.length; i++) {
          if (
            S(item.keywordContents[i].value.toLocaleLowerCase())
              .latinise()
              .contains(searchString.s)
          ) {
            return true;
          }
        }

        return false;
      });
    },
    addKeywordsToContract() {
      let that = this;
      var keywordIdsToAdd = [];

      for (var i = 0; i < this.keywordsToAdd.length; i++) {
        if (
          this.contractKeywords.filter((keyword) => {
            return keyword.id == this.keywordsToAdd[i].keywordId;
          }).length == 0
        ) {
          keywordIdsToAdd.push({ keywordId: this.keywordsToAdd[i].keywordId });
        }
      }

      AddKeywordsToContract(
        this.contractId,
        keywordIdsToAdd,
        () => {
          that.keywordsToAdd = [];
          that.reloadKeywordsForContract();
        },
        (error) => {
          that.errorObject = error;
        },
      );
    },

    cancelEditingKeywords() {
      this.keywordsToAdd = [];
    },

    deleteKeyWordRelation() {
      this.hideModal();
      let that = this;

      DeleteKeywordFromContract(
        this.contractId,
        this.keywordToDelete.id,
        (result) => {
          console.log(result);
          that.keywordToDelete = null;
          that.reloadKeywordsForContract();
        },
        (error) => {
          that.errorObject = error;
        },
      );
    },

    hideModal() {
      this.$refs.confirmDeleteKeyWord.hide();
    },

    reloadKeywordsForContract() {
      let that = this;

      GetKeywordsForContract(
        this.contractId,
        (result) => {
          that.contractKeywords = result.data;
        },
        (error) => {
          that.errorObject = error;
        },
      );
    },
    reloadAllKeyWords() {
      this.errorObject = null;
      this.isLoading = true;
      let that = this;

      GetAllKeywords(
        that.maxNumberOfItems,
        that.searchToAdd,
        null,
        (result) => {
          that.totalNumberOfItems = result.numberOfItems;
          that.allKeyWords = result.keywords;

          that.keywordsToAdd.map((keyword) => {
            if (
              that.allKeyWords.filter((resultKeyword) => {
                return resultKeyword.keywordId == keyword.keywordId;
              }).length == 0
            ) {
              that.allKeyWords.push(keyword);
            }
          });

          that.isLoading = false;
        },
        (error) => {
          that.errorObject = error;
          that.isLoading = false;
        },
      );
    },

    removeKeyword(keyword) {
      this.keywordsToAdd = this.keywordsToAdd.filter((filterItem) => {
        return filterItem.keywordId != keyword.keywordId;
      });
    },
  },
};
</script>

<style>
.mutliselectSelectionItem {
  padding: 4px 11px;
  background-color: rgb(0, 140, 255);
  color: white;
  border-radius: 5px;
}
.mutliselectSelectionItem i {
  margin-left: 5px;
  font-size: 14px;
}
.loadMoreKeywords:hover {
  background-color: rgb(205, 233, 255);
}
</style>
